export default function Contact() {
  return (
    <section id="contact" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <h3 className="text-5xl md:text-6xl font-black text-black mb-6 tracking-tight uppercase">
            Contactez-Nous
          </h3>
          <div className="w-24 h-1 bg-black mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto font-light">
            Prêt à commencer votre aventure ? Écrivez-nous pour réserver vos cours
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="border-4 border-black overflow-hidden">
            <div className="grid md:grid-cols-2">
              <div className="p-12 bg-black text-white">
                <h4 className="text-4xl font-black mb-8 uppercase tracking-tight">Envoyez-nous un Email</h4>
                <p className="text-gray-300 mb-12 leading-relaxed font-light text-lg">
                  Notre équipe est à votre écoute pour répondre à toutes vos questions et vous aider à organiser vos cours de ski.
                </p>

                <div className="space-y-8">
                  <div className="flex items-start space-x-4 border-l-4 border-white pl-6">
                    <div className="w-12 h-12 flex items-center justify-center bg-white text-black flex-shrink-0">
                      <i className="ri-phone-line text-2xl"></i>
                    </div>
                    <div>
                      <div className="font-bold mb-2 uppercase tracking-wide text-sm">Téléphone</div>
                      <a 
                        href="tel:+33479567411" 
                        className="text-white hover:text-gray-300 transition-colors cursor-pointer text-lg"
                      >
                        +33 4 79 56 74 11
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start space-x-4 border-l-4 border-white pl-6">
                    <div className="w-12 h-12 flex items-center justify-center bg-white text-black flex-shrink-0">
                      <i className="ri-mail-line text-2xl"></i>
                    </div>
                    <div>
                      <div className="font-bold mb-2 uppercase tracking-wide text-sm">Email</div>
                      <a 
                        href="mailto:contact@esf-orelle.fr" 
                        className="text-white hover:text-gray-300 transition-colors cursor-pointer text-lg"
                      >
                        contact@esf-orelle.fr
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start space-x-4 border-l-4 border-white pl-6">
                    <div className="w-12 h-12 flex items-center justify-center bg-white text-black flex-shrink-0">
                      <i className="ri-map-pin-line text-2xl"></i>
                    </div>
                    <div>
                      <div className="font-bold mb-2 uppercase tracking-wide text-sm">Localisation</div>
                      <div className="text-gray-300 text-lg">Orelle, Savoie</div>
                      <div className="text-gray-300">Les Trois Vallées</div>
                    </div>
                  </div>

                  <div className="flex items-start space-x-4 border-l-4 border-white pl-6">
                    <div className="w-12 h-12 flex items-center justify-center bg-white text-black flex-shrink-0">
                      <i className="ri-time-line text-2xl"></i>
                    </div>
                    <div>
                      <div className="font-bold mb-2 uppercase tracking-wide text-sm">Saison</div>
                      <div className="text-gray-300 text-lg">Début Décembre à Fin Avril</div>
                      <div className="text-gray-300">7j/7 - Neige d'exception garantie</div>
                    </div>
                  </div>

                  <div className="flex items-start space-x-4 border-l-4 border-white pl-6">
                    <div className="w-12 h-12 flex items-center justify-center bg-white text-black flex-shrink-0">
                      <i className="ri-snowy-line text-2xl"></i>
                    </div>
                    <div>
                      <div className="font-bold mb-2 uppercase tracking-wide text-sm">Snowpark</div>
                      <div className="text-gray-300 text-lg">Accès toute la saison</div>
                      <div className="text-gray-300">Décembre à Avril</div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="relative h-full min-h-[500px]">
                <img 
                  src="https://static.readdy.ai/image/71745ccb8c79f3954a4900c745433851/17629f65c7745683f7e8cbddb2b4a703.jpeg"
                  alt="Orelle"
                  className="absolute inset-0 w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>

          <div className="mt-16 flex flex-col sm:flex-row gap-6 justify-center items-center">
            <a 
              href="tel:+33479567411" 
              className="inline-flex items-center justify-center bg-black text-white px-12 py-6 text-xl font-black hover:bg-gray-800 transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap tracking-wide uppercase border-4 border-black hover:border-gray-800"
            >
              <i className="ri-phone-line mr-3 text-2xl"></i>
              Appelez-Nous
            </a>
            
            <a 
              href="mailto:contact@esf-orelle.fr" 
              className="inline-flex items-center justify-center bg-white text-black px-12 py-6 text-xl font-black hover:bg-gray-100 transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap tracking-wide uppercase border-4 border-black"
            >
              <i className="ri-mail-send-line mr-3 text-2xl"></i>
              Envoyer un Email
            </a>
            
            <a 
              href="mailto:contact@esf-orelle.fr?subject=Don pour Orelle Freeski" 
              className="inline-flex items-center justify-center bg-white text-black px-12 py-6 text-xl font-black hover:bg-gray-100 transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap tracking-wide uppercase border-4 border-black"
            >
              <i className="ri-heart-line mr-3 text-2xl"></i>
              Faire un Don
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}